import BookingContainer from './components/bookingContainer'
import PatientContainer from './components/patientContainer'
import { getColumnWidth } from './logic/getColumnWidth'
import { Col, Row, Tabs } from 'antd'
import { BreadCrumb, Button } from 'components/atoms'
import { MainHeader } from 'components/templates'
import { NO_DATA } from 'constants/common'
import { SEARCH_QUERY_PATIENT_DEFAULT, SEARCH_QUERY_URL } from 'constants/query'
import { useProfile, useQuery, useQuerySearch } from 'hooks'
import moment from 'moment'
import { IPatient } from 'pages/patientReceive/interfaces'
import useModalReceive from 'pages/patientReceive/logic/useModalReceive'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useReceiveServices } from 'services'
import styled from 'styled-components'
import { getDateOfBirthString, getOldPatient } from 'utils'
import { exportToExcel } from 'utils/exportExcel'

const StyledButton = styled(Button)`
  position: relative;
  bottom: 8px;
`

export enum TabTypeBooking {
  Patient = 'patient',
  Booking = 'booking'
}

interface IProps {
  tab?: TabTypeBooking
}

const BookingPage = (props: IProps) => {
  const { tab } = props
  const { t } = useTranslation()
  const navigate = useNavigate()
  const query = useQuery()
  const tabSelected = query.get('tab') || tab || TabTypeBooking.Patient
  const { handleAddNewProfile } = useModalReceive()
  const patientRef = useRef<any>()
  const { searchPatient } = useReceiveServices()
  const { profile } = useProfile()
  const handleOnChangeTab = (tabSelected: string) => {
    navigate(`/booking/${tabSelected}`)
  }
  const { payloadSearch } = useQuerySearch<IPatient>(
    SEARCH_QUERY_URL.Patient,
    SEARCH_QUERY_PATIENT_DEFAULT
  )
  const handleExportExcel = async () => {
    const res = await searchPatient({
      ...payloadSearch,
      offset: undefined,
      limit: 10000000
    })
    if (res) {
      const dataExcel = res.data.patients.map((item: IPatient, index) => {
        return {
          hash: index + 1,
          user_code: item?.user_code || NO_DATA,
          full_name: item?.full_name || NO_DATA,
          date_of_birth: getDateOfBirthString(
            item?.date,
            item?.month,
            item?.year
          ),
          phone_number: item?.phone_number || NO_DATA,
          email: item?.email || NO_DATA,
          gender: t(`gender-${item?.gender}`),
          old: item?.year ? getOldPatient(item?.year) : NO_DATA,
          address: item?.address || NO_DATA,
          have_upcoming_booking: item?.have_upcoming_booking
            ? t('has-booking')
            : t('no-has-booking')
        }
      })
      const headerNames = [
        t('hash'),
        t('pa-code'),
        t('fullname'),
        t('birthday-date'),
        t('phone-number'),
        t('email'),
        t('gender'),
        t('old'),
        t('address'),
        t('booking-status')
      ]
      const columnWidths = getColumnWidth(dataExcel, headerNames)
      exportToExcel(
        `DS Benh Nhan - ${moment(new Date()).format('DD.MM.YYYY')}`,
        dataExcel,
        {
          headerNames: headerNames,
          columnWidths: columnWidths
        }
      )
    }
  }
  const tabBooking = []
  if (
    profile?.my_clinic_user.clinic_role.permission.patient_management
      .patient === true
  ) {
    tabBooking.push({
      label: t('patient').toUpperCase(),
      key: TabTypeBooking.Patient,
      children: <></>
    })
  }

  if (
    profile?.my_clinic_user.clinic_role.permission.patient_management
      .booking === true
  ) {
    tabBooking.push({
      label: t('booking').toUpperCase(),
      key: TabTypeBooking.Booking,
      children: <></>
    })
  }
  return (
    <MainHeader
      headerTitle={
        <BreadCrumb
          breadCrumbs={[
            { name: 'patient-management', path: '/' },
            { name: `${tabSelected}`, path: '' }
          ]}
        />
      }
      stickyHeader>
      <Tabs
        tabBarExtraContent={
          tabSelected === TabTypeBooking.Patient ? (
            <Row gutter={6}>
              <Col>
                <StyledButton
                  type="primary"
                  size="small"
                  color="green"
                  icon={<img src="/images/ic-add.svg" alt="" />}
                  onClick={() =>
                    handleAddNewProfile(
                      () => patientRef.current && patientRef.current?.reload()
                    )
                  }>
                  {t('add-patient')}
                </StyledButton>
              </Col>
              <Col>
                <StyledButton
                  type="primary"
                  size="small"
                  color="green"
                  onClick={handleExportExcel}>
                  {t('export-excel')}
                </StyledButton>
              </Col>
            </Row>
          ) : (
            <></>
          )
        }
        onChange={handleOnChangeTab}
        activeKey={tabSelected}
        items={tabBooking}
      />
      {tabSelected === TabTypeBooking.Booking && <BookingContainer />}
      {tabSelected === TabTypeBooking.Patient && (
        <PatientContainer ref={patientRef} />
      )}
    </MainHeader>
  )
}

export default BookingPage
